export default function CTAFinal() {
  return (
    <section className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/42f5b51064f1f30f034d6154dc968d4b.jpg"
          alt="Vista aérea construção Flórida"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative h-full max-w-7xl mx-auto px-6 lg:px-12 flex flex-col justify-between py-32">
        <div className="max-w-2xl">
          <h2 className="text-6xl lg:text-7xl font-bold text-white leading-tight lowercase">
            Quer entender qual projeto faz sentido pra você?
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end">
          <a
            href="https://wa.me/5511999999999"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center space-x-4 bg-white rounded-full pl-8 pr-3 py-3 hover:shadow-2xl transition-all cursor-pointer"
          >
            <span className="text-black font-semibold text-lg">Falar no WhatsApp</span>
            <div className="w-12 h-12 bg-black rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
              <i className="ri-arrow-right-line text-white text-xl"></i>
            </div>
          </a>

          <div className="text-right mt-8 lg:mt-0">
            <p className="text-white text-xl font-light">
              Converse com nosso time e descubra<br />
              a melhor forma de começar.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
